import { Input } from '@grofers/react';
import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import styled from 'styled-components';
import { Heading, Dropdown } from '../../../UiKit';
import { Star } from '../../../UiKit/Star/Star';
import { useCreateUpdateAgent } from '../apis';
import { grey } from 'sushiweb/tokens/color';
import Spinner from 'sushiweb/Spinner/Spinner';
import Button from '../../../components/ComponentsV1/Button';

function CreateUpdateAgent() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [action, setAction] = useState('');
  const [number, setNumber] = useState('');
  const [error, setError] = useState({});

  const { mutate, isLoading } = useCreateUpdateAgent(action, {
    onSuccess: () => {
      setName('');
      setEmail('');
      setAction('');
      setNumber('');
      setError('');
    },
  });

  const validateEmail = (email) => {
    if (!email) return false;
    if (/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/.test(email)) {
      return true;
    }
    setError({ email: 'Invalid Email Id' });
    return false;
  };

  const validateMobileNumber = (number) => {
    const isChar =
      number.includes('-') || number.includes('+') || number.includes('e');
    if (!number && !isChar) return;
    if (number.length != '10') {
      setError({ number: 'Invalid mobile number' });
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !email || !action || !number) {
      toast.error('Please fill all the mandatory fields.');
      return null;
    }

    const dataToSubmit = {
      user: {
        name: name,
        email_id: email,
        phone: '+91' + number,
      },
    };
    mutate(dataToSubmit);
  };

  return (
    <FormConatiner>
      <div
        css={`
          display: flex;
          gap: 2rem;
          width: 100%;
          flex-wrap: wrap;
        `}
      >
        <FieldRowOne>
          <Label>
            <div>
              <Heading title='Name' color='#1F1F1F' weight='600' size='17px' />
              <Star icon='*' />
            </div>
            <Input
              placeholder='Enter name'
              style={{
                padding: '1.22rem 1rem',
                fontWeight: '400',
                fontSize: '1.33rem',
              }}
              onChange={(e) => setName(e.target.value)}
              type='text'
              value={name}
              data-dd-privacy='mask'
            />
          </Label>
          <Label>
            <div>
              <Heading
                title='Email id'
                color='#1F1F1F'
                weight='600'
                size='17px'
              />
              <Star icon='*' />
            </div>
            <Input
              placeholder='Enter email id'
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onFocus={() => {
                setError((prevState) => {
                  return { ...prevState, email: '' };
                });
              }}
              onBlur={(e) => {
                validateEmail(e.target.value);
              }}
              style={{
                outline: `${error?.email ? '1px solid #BF2938' : ''}`,
                padding: '1.22rem 1rem',
                fontWeight: '400',
                fontSize: '1.33rem',
              }}
              data-dd-privacy='mask'
            />
            {error?.email && (
              <div
                css={`
                  color: #bf2938;
                  margin-top: 0.5rem;
                `}
              >
                {error?.email}
              </div>
            )}
          </Label>
        </FieldRowOne>
        <FieldRowTwo>
          <Label>
            <div>
              <Heading
                title='Mobile Number'
                color='#1F1F1F'
                weight='600'
                size='17px'
              />
              <Star icon='*' />
            </div>
            <Input
              placeholder='Enter phone number'
              type='number'
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              onFocus={() => {
                setError((prevState) => {
                  return { ...prevState, number: '' };
                });
              }}
              onBlur={(e) => {
                validateMobileNumber(e.target.value);
              }}
              style={{
                outline: `${error?.number ? '1px solid #BF2938' : ''}`,
                padding: '1.22rem 1rem',
                fontWeight: '400',
                fontSize: '1.33rem',
              }}
              data-dd-privacy='mask'
            />
            {error?.number && (
              <div
                css={`
                  color: #bf2938;
                  margin-top: 0.5rem;
                `}
              >
                {error?.number}
              </div>
            )}
          </Label>
          <Label>
            <div>
              <Heading
                title='Action'
                color='#1F1F1F'
                weight='600'
                size='17px'
              />
              <Star icon='*' />
            </div>
            <div
              css={`
                display: flex;
                flex-direction: row;
                gap: 1.5rem;
                width: '100%';
                div {
                  width: 100%;
                }
              `}
              onClickCapture={(event) => {
                event.preventDefault();
              }}
            >
              <Dropdown
                dropDownValues={{
                  create_user: 'Create',
                  update_user: 'Update',
                }}
                onSelect={(value) => setAction(value)}
                dropdownVal={action}
                placeholder='Select an action'
              />
            </div>
          </Label>
        </FieldRowTwo>
      </div>

      <Button
        onClick={handleSubmit}
        title={'Submit'}
        loading={isLoading}
        className={'tw-w-fit'}
      />
    </FormConatiner>
  );
}

export default CreateUpdateAgent;

const FormConatiner = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  border-radius: 1rem;
  padding: 1.5rem;
  display: flex;
  gap: 4rem;
  flex-direction: column;
`;

const FieldRowOne = styled.div`
  width: 100%;
  display: flex;
  gap: 3rem;
`;
const FieldRowTwo = styled.div`
  width: 50%;
  display: flex;
  gap: 3rem;
`;

const Label = styled.label`
  width: 100%;
`;
